import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { Box, Container, useMediaQuery } from "@mui/material";
import { ArrowForwardIosRounded } from "@mui/icons-material";
import { darkGreen } from "../Resources/Design/theme";
import MotionAppear from "./MotionAppear";
import { fullCenter, pastelBlue, pastelDark, pastelRed, titleStyle } from "../Pages/Main/constants";
import { EditableTypography } from "./EditableTypography";
import Centered from "./Centered";
import { useFirestore } from "../Firebase/FirestoreProvider";
import { useAuth } from "../Firebase/AuthProvider";

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    "&:not(:last-child)": {
        borderBottom: 0,
    },
    "&:before": {
        display: "none",
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        sx={{
            backgroundColor: "#fff",
            borderLeft: "none",
        }}
        expandIcon={
            <ArrowForwardIosRounded
                sx={{
                }}
            />
        }
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: "#fff",
    borderLeft: "none",
    flexDirection: "row",
    "& .MuiButtonBase-root.MuiAccordionSummary-root": {
        backgroundColor: "#fff",
        borderLeft: "none",
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
        transform: "rotate(90deg)",
    },
    "& .MuiAccordionSummary-content": {},
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const mapSrcDef = "https://www.google.com/maps/d/u/0/embed?mid=14651m2QP0GXzo8S4yivdizXeomZLTPU&ehbc=2E312F&noprof=1";

const GoogleMap = ({ mapSrc = mapSrcDef }) => {
    return <Box sx={{ display: 'flex', justifyContent: 'flex-start', my: '16px' }}>
        <iframe
            title="GoogleMap"
            src={mapSrc}
            width="500" height="350" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade">
        </iframe>
    </Box>
}

export default function OftenAsked({
    sxTitle = {},
    sxContainer = {}
}) {
    const { isAdmin } = useAuth();
    const [move, setMove] = useState(null);
    const { data, changeData } = useFirestore();
    const oftenAsked = data?.often_asked || [];

    if (window.navigator.userAgent.includes('ReactSnap')) {
        return <></>;
    }

    return (
        <div>
            <Container
                maxWidth="md"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    px: '0px !important',
                    //px: NAVBAR_SPACE,

                    ...sxContainer,
                }}
            >
                <Centered>
                    <EditableTypography
                        fireKey={'often_asked_title'}
                        sx={{
                            mb: "120px",
                            width: '100%',
                            ...titleStyle,
                            textAlign: 'center',
                            ...sxTitle,
                        }}
                    />
                </Centered>
                {oftenAsked.map((data, i) => (
                    <MotionAppear amount={0.2} style={{}} key={`OftenAskedMOT` + i}>
                        <Accordion
                            key={`OftenAskedAccI` + i}
                            sx={{
                                backgroundColor: "#fff",
                                borderLeft: "none",
                                borderRight: "none",
                            }}
                            onMouseEnter={() => {
                                setMove({ i });
                            }}
                            onMouseLeave={() => {
                                if (move?.i === i) {
                                    setMove(null);
                                }
                            }}
                        >
                            <AccordionSummary
                                expandIcon={
                                    <ArrowForwardIosRounded
                                        sx={{
                                            fontSize: "22px",
                                            color: pastelDark,
                                            fontWeight: 800,
                                            transform:
                                                move?.i === i
                                                    ? "translateX(4px)"
                                                    : "translateX(0px)",
                                            transition: "transform 0.2s ease",

                                        }}
                                    />
                                }
                                aria-controls={`often-asked${i}`}
                                id={`often-asked-header${i}`}
                            >
                                <EditableTypography
                                    bottom={-3}
                                    right={-50}
                                    path={`often_asked.${i}.title`}
                                    sx={{
                                        textAlign: "left",
                                        fontFamily: 'inter', fontWeight: 600,
                                        fontSize: '18px', minHeight: '22px'
                                    }}
                                />
                            </AccordionSummary>
                            <AccordionDetails>
                                <EditableTypography bottom={0} path={`often_asked.${i}.text`} sx={{ textAlign: "left", minHeight: '56px' }} />
                                {Boolean(data.map) && <GoogleMap mapSrc={typeof data.map === "string" ? data.map : undefined} />}
                                {Boolean(data.map) && isAdmin && <EditableTypography bottom={0} path={`often_asked.${i}.map`} sx={{ textAlign: "left", minHeight: '56px' }} />}
                            </AccordionDetails>

                        </Accordion>
                    </MotionAppear>
                ))}
                {isAdmin && <Box sx={{ display: 'flex', flexDirection: 'row' }}><Box component='span'
                    sx={{
                        width: '34px', height: '34px', maxWidth: '34px', maxHeight: '34px', minWidth: '34px', borderRadius: '50%',
                        bgcolor: pastelBlue,
                        scale: 1,
                        transition: 'scale 0.2s ease-in-out',
                        "&:hover": { scale: 1.05 },
                        zIndex: 14, cursor: 'pointer', ...fullCenter, mt: '12px'
                    }}
                    onClick={(e) => {
                        if (isAdmin) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        const newOftenAsked = [...oftenAsked, { title: '', text: '' }]
                        changeData('often_asked', newOftenAsked);

                    }} onMouseDown={(e) => {
                        if (isAdmin) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }}>

                    <Typography sx={{ fontWeight: 'bold', fontSize: '28px', mb: '4px' }}>+</Typography>
                </Box>
                    <Box component='span'
                        sx={{
                            width: '34px', height: '34px', maxWidth: '34px', maxHeight: '34px', minWidth: '34px', borderRadius: '50%',
                            bgcolor: pastelRed,
                            scale: 1,
                            transition: 'scale 0.2s ease-in-out',
                            "&:hover": { scale: 1.05 }, ml: '12px',
                            zIndex: 14, cursor: 'pointer', ...fullCenter, mt: '12px'
                        }}
                        onClick={(e) => {
                            if (isAdmin) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                            const newOftenAsked = [...oftenAsked].slice(0, -1);
                            changeData('often_asked', newOftenAsked);

                        }} onMouseDown={(e) => {
                            if (isAdmin) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        }}>

                        <Typography sx={{ fontWeight: 'bold', fontSize: '28px', mb: '4px' }}>-</Typography>
                    </Box>
                </Box>}
            </Container>
        </div>
    );
}
